








































import { Component, Prop, Vue } from 'vue-property-decorator';

import EditIcon from '@/components/icons/EditIcon.vue';

import CategoryItem from '@/components/molecules/CategoryItemV2/CategoryItem.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { Picture } from '@/components/atoms';
import { IBusinessType } from '@/models/business';

@Component({
  components: { Typography, EditIcon, CategoryItem, Picture }
})
export default class GooglePreviewBusiness extends Vue {
  @Prop() data!: any;

  get name() {
    return this.data.businessName;
  }

  get website() {
    if (this.data.operationType === IBusinessType.INSTORE) return '';
    return this.data.website;
  }

  get address() {
    return this.data.address.fullAddress;
  }

  get phone() {
    if (!this.data.phone || !this.data.phone.number) return '';

    return this.data.phone;
  }

  get category() {
    return this.data.category.otherValue || this.data.category.name;
  }

  get categoryIcon() {
    return this.data.category.name;
  }

  imageSrc(name: string) {
    return require(`@/assets/img/business-onboarding/business-preview/${name}.png`);
  }

  get selectedCountry() {
    return this.$store.getters['businessOnboarding/getSelectedCountry'];
  }

  get vueMask() {
    return this.selectedCountry.phoneMask;
  }

  edit() {
    this.$emit('edit');
  }
}
